import React, {Component, Fragment} from "react";
import './index.css';
import Group from "../../Components/Group";
import Hospital from "../../Server/Hospital";
import moment from "jalali-moment";
import LabelValueTable from "../LabelValueTable";
import ModalHospitalInventoryList from "../Modal/ModalHospitalInventoryList";
import Perms from '../../Perms';
import ModalInjectionMonitoring from "../Modal/ModalInjectionMonitoring";

class Dashboard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            miniStatistics: [],
            table: {
                rows: [],
                headerRow: [],
                startCol: []
            },
            colors: ['#e76f51', '#f4a261', '#e9c46a', '#2a9d8f', '#264653', '#3d5a80', '#98c1d9']
        };

        this.ref = {
            modalHospitalInventoryList: React.createRef(),
            modalInjectionMonitoring: React.createRef()
        };
    }

    componentDidMount() {
        // this.ref.modalInjectionMonitoring.current.open();

        if (Perms().DASHBOARD.SHOW_BLOOD_BANK_INVENTORY) {
            Hospital.inventory()
                .then(data => {
                    const headerRow = data.productTypes.map(item => {
                        return {
                            value: item.shortName,
                            data: item
                        };
                    });
                    const startCol = data.bloodGroups.map(item => {
                        return {
                            value: item.name,
                            data: item
                        };
                    });
                    const rows = data.bloodGroupList.map(bloodGroup => bloodGroup.map(item => {
                        return {
                            value: item.inventory,
                            data: item
                        };
                    }));
                    this.setState({table: {headerRow, startCol, rows}});
                });

            Hospital.miniStatistic({
                startDate: moment().startOf('jday').format(),
                endDate: moment().endOf('jday').format()
            })
                .then(data => {
                    this.setState({
                        miniStatistics: [
                            ...data.enterExit_StatisticVM.map(item => {
                                return {label: item.statusStr, count: item.count || 0};
                            }),
                            ...data.sectionRequest_Statistic.map(item => {
                                return {label: item.formTypeStr, request: item.totalRequestCount, product: item.totalProductCount};
                            })
                        ]
                    });
                });
        }
    }

    render() {
        return <Fragment>
            <div className="dis-f" style={{direction: "rtl"}}>
                <div className={'dis-f fb-20'} style={{padding: 5, justifyContent: 'center'}}>
                    {this.state.miniStatistics.map((item, index) => item.count !== undefined ?
                        <div key={index} className={'mini-statistic'}>
                            <div style={{backgroundColor: this.state.colors[index % 7]}}>
                                <p>{item.label}</p>
                                <span>{item.count}</span>
                            </div>
                        </div> :
                        <div key={index} className={'mini-statistic big'}>
                            <div style={{backgroundColor: this.state.colors[index % 7]}}>
                                <p>{item.label}</p>
                                <span>{item.request} <strong style={{fontSize: '12px'}}>درخواست</strong> {item.product} <strong style={{fontSize: '12px'}}>فرآورده</strong></span>
                            </div>
                        </div>)}
                </div>
                {this.state.table?.rows?.length ? <div className="fb-20 dis-4x-n" id={'inventory-table'}>
                    <Group className={'mar-10'} title={'موجودی بانک خون (تعداد رزرو)'}>
                        <LabelValueTable {...this.state.table} maximizable={true} onClick={this.labelValueTableCellClickHandler.bind(this)}/>
                    </Group>
                </div> : null}
            </div>
            <ModalHospitalInventoryList refer={this.ref.modalHospitalInventoryList}/>
            <ModalInjectionMonitoring refer={this.ref.modalInjectionMonitoring}/>
        </Fragment>;
    }

    labelValueTableCellClickHandler(data) {
        if (data?.inventory) {
            this.ref.modalHospitalInventoryList.current.open({
                    bloodGroupId: data?.bloodGroupId,
                    productTypeId: data?.productTypeId
                },
                'HOSPITAL_INVENTORY');
        }
    }
}

export default Dashboard;